import React from 'react'
import FieldConfig from "../../../proto/field-config"
import FieldProto from "../../../proto/field-proto"
import {FieldType} from "../../../field-type"
import FieldDateRangeRelativePeriod_FormElementView from "./render/form-element-view"

export enum DateRangeRelativePeriod {
    WEEK    = 'week',
    MONTH   = 'month',
    YEAR    = 'year',
}

export enum DateRangeRelativity {
    THIS    = 'this',
    LAST    = 'last',
}

export type DateRangeRelativePeriodValue = {
    relativity  : DateRangeRelativity
    period      : DateRangeRelativePeriod
}

export const RELATIVE_PERIOD_DEFAULT_VALUE = {
    period      : DateRangeRelativePeriod.WEEK,
    relativity  : DateRangeRelativity.THIS
}

export default class FieldDateRangeRelativePeriod extends FieldProto {
    constructor(config:FieldConfig) {
        config.type = FieldType.DATE_RANGE_RELATIVE_PERIOD

        super(config)

        this.typeLabel          = "Date range"
        this.icon               = 'i5-calendar'

        _.assign(this.renderComponents, {
            formElementView     : FieldDateRangeRelativePeriod_FormElementView
        })
    }
}
